import React from 'react';
const bloques = [{
  etiqueta: 'Sobre el precio',
  texto: 'Piensa en cuánto ya te costó este dolor — no en dinero, sino en energía, en relaciones que no avanzaron por este peso sin resolver. El costo de seguir atrapado casi siempre es más alto que la inversión de resolverlo de una vez.'
}, {
  etiqueta: 'Sobre el tiempo',
  texto: 'El programa está diseñado con una sola sesión semanal de máximo 90 minutos, más el acompañamiento por WhatsApp en los momentos que a ti te queden cómodos. Siempre vamos a sentir que "no es el momento perfecto" — el momento se construye, no se espera.'
}];
export function ObjecionesSection() {
  return <section aria-label="Dudas frecuentes sobre la inversión y el tiempo" className="border-b border-violet-line/40 bg-violet" data-id="element-47" data-mp="13pf6pwltyy8c">
      <div className="mx-auto grid max-w-5xl gap-12 px-6 py-20 sm:py-24 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-48" data-mp="33186g1006hor">
        {bloques.map(bloque => <div key={bloque.etiqueta} className="flex h-full flex-col" data-id="element-49" data-mp="2y1n8ntwkkfdm">
            <h3 className="font-serif text-2xl font-medium text-gold-soft sm:text-3xl" data-id="element-50" data-mp="15g9noefxxbl5">
              {bloque.etiqueta}
            </h3>
            <p className="mt-4 font-sans text-base font-light leading-relaxed text-bone/75" data-id="element-51" data-mp="vjdfk9tyerh4">
              {bloque.texto}
            </p>
          </div>)}
      </div>
    </section>;
}